module.exports = __webpack_public_path__ + "static/media/v02-01.be2f69f8.png";